import React from 'react'
import SelectionsDisplayList from '../SelectionsDisplayList'
import WrapperReactPage from  '../General/WrapperReactPage'
import withLatencyTest from '../hooks/withLatencyTest'
import getCookie from '../functions/getCookie'
import EntryPagesChildClass from '../General/EntryPagesChildClass'
import { setYoutubeCookieConfirmation } from '../actions'
import getData from '../functions/getData'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import { ADVERTISEMENT_CONFIG, CLI, FEATURES, FRONT, PROGRAM_ADS, PROGRAM_ADVERTISEMENTS, PROGRAM_CINEMAS, PROGRAM_COLLECTIONS_ITEMS, PROGRAM_ELBENWALDARTICLES_ITEMS, PROGRAM_HIGHLIGHTS, PROGRAM_MOVIES, PROGRAM_SELECTIONS_ITEMS, PROGRAM_SELECTIONSDISPLAY, PROGRAM_WEISCHERADS, ROUTESDATA, THEME, TRANSLATION } from '../constants/state'
import hasCookieCheck from '../functions/hasCookieCheck'
import TrailerPopupWrapper from '../Trailer/TrailerPopupWrapper'
import withUseCssVars from '../hooks/withUseCssVars'

const mapDispatchToProps = (dispatch, ownProps) => ({
    setYoutubeCookieConfirmation: (bool) => {
        dispatch(setYoutubeCookieConfirmation(bool))
    }
})

const mapStateToProps = (state, ownProps) => ({
    itemCollections: getData(state, PROGRAM_COLLECTIONS_ITEMS), 
    itemSelections: getData(state, PROGRAM_SELECTIONS_ITEMS), 
    itemSelectionsDisplay: getData(state, PROGRAM_SELECTIONSDISPLAY), 
    cinemaDataFront: getData(state, FRONT), 
    movies: getData(state, PROGRAM_MOVIES),
    advertisements: getData(state, PROGRAM_ADVERTISEMENTS), 
    ads: getData(state, PROGRAM_ADS), 
    features: getData(state, FEATURES),
    highlights: getData(state, PROGRAM_HIGHLIGHTS), 
    weischerAds: getData(state, PROGRAM_WEISCHERADS),  
    theme: getData(state, THEME), 
    routesData: getData(state, ROUTESDATA), 
    translation: getData(state, TRANSLATION), 
    elbenwaldItems: getData(state, PROGRAM_ELBENWALDARTICLES_ITEMS),
    cinemas: getData(state, PROGRAM_CINEMAS),
    cliData: getData(state, CLI),
    advertisementConfig: getData(state, ADVERTISEMENT_CONFIG)
})

class PageFront extends EntryPagesChildClass {
    constructor(props) {
        super(props)

        this.state = {
            isScrolled: false
        }

        this.onScrollPage = this.onScrollPage.bind(this)
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScrollPage)

        const {setYoutubeCookieConfirmation} = this.props 
        window.addEventListener('borlabs-cookie-consent-saved', () => {hasCookieCheck(setYoutubeCookieConfirmation)})
        window.addEventListener('borlabs-cookie-code-unblocked', () => {hasCookieCheck(setYoutubeCookieConfirmation)})
        window.addEventListener('borlabs-cookie-handle-unblock', () => {hasCookieCheck(setYoutubeCookieConfirmation)})
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollPage)
        
        const { setYoutubeCookieConfirmation } = this.props
        window.removeEventListener('borlabs-cookie-consent-saved', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-code-unblocked', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-handle-unblock', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
    }

    onScrollPage() {
        if (window.scrollY > window.innerHeight && this.state.isScrolled === false) {
            this.setState({
                isScrolled: true
            })
        }
    }

    render() {
        const { 
            isConnectedFast,
            itemCollections,
            itemSelections,
            itemSelectionsDisplay,
            cinemaDataFront,
            movies,
            advertisements,
            ads,
            features,
            highlights,
            weischerAds,
            theme,
            routesData,
            translation,
            elbenwaldItems,
            cliData,
            cinemas,
            advertisementConfig
        } = this.props

        const {
            program_overview_showtimes_type,
            header_appearance,
            content_width,
            poster_styling,
            information_style,
            hidden_attributes,
            highlight_appearance,
            ignore_attributes_for_performance_filter,
            details_style,
            attribute_styling,
            stripe_appearance,
            slider_appearance,
            small_slider_appearance,
            show_availableIn
        } = cinemaDataFront

        const {has_chatbot} = features
        const {theme_colors} = theme
        const {main_slider_advertisement_positioning} = advertisementConfig

        const elbenwald = EntryPagesChildClass.getElbenwald(features, elbenwaldItems, cliData, cinemas)

        const moviesRoutesData = routesData.movies.items
        const cookieExists = getCookie('fireplace')
        const isScrolledClass = this.state.isScrolled || cookieExists ? ' is-scrolled' : ''

        if(!movies) {
            return ''
        }

        return (
            <WrapperReactPage headerAppearance={header_appearance} hasChatbot={has_chatbot} features={features} contentWidth={content_width} advertisements={advertisements} isScrolledClass={isScrolledClass} buyTicketAnimation={true} movies={movies} translation={translation}>
                <SelectionsDisplayList
                    showAvailableIn={show_availableIn}
                    sliderAppearance={slider_appearance}
                    smallSliderAppearance={small_slider_appearance}
                    stripeAppearance={stripe_appearance}
                    attributeStyling={attribute_styling}
                    detailsStyling={details_style}
                    hiddenAttributes={hidden_attributes}
                    ignoreAttributesForPerformanceFilter={ignore_attributes_for_performance_filter}
                    highlightAppearance={highlight_appearance}
                    informationStyling={information_style}
                    posterStyling={poster_styling}
                    mainSliderAdvertisementPositioning={main_slider_advertisement_positioning}
                    theme={theme_colors}
                    programOverviewShowtimesType={program_overview_showtimes_type}
                    routesData={routesData}
                    moviesRoutesData={moviesRoutesData}
                    translation={translation}
                    itemSelectionsDisplay={itemSelectionsDisplay}
                    itemSelections={itemSelections}
                    itemCollections={itemCollections}
                    movies={movies.items}
                    highlights={highlights}
                    ads={ads}
                    advertisements={advertisements}
                    weischerAds={weischerAds}
                    elbenwald={elbenwald}
                    features={features}
                    isConnectedFast={isConnectedFast}
                />
                <TrailerPopupWrapper/>
            </WrapperReactPage>
        )
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(withUseCssVars(withLatencyTest(PageFront)))